module.exports = __webpack_public_path__ + "fonts/Circe-ExtraBold.84a6ea5c.woff2";